import { BaseUrl, NewUpdatedBaseUrl } from "../../BaseUrl/BaseUrl";
import { getApiWithAuthorization, getApiWithoutAuthorization, postApiWithAuthorization, postApiWithoutAuthorization } from "../ApiMethod/ApiMethod";


export const Estore_order = async (params) => {
  const url = `${BaseUrl}/Estore_order`;
  const res = await postApiWithoutAuthorization(url, params);
  return res;
};


export const GetDeliveryCharges = async (stateID, districtID) => {
  const url = `${BaseUrl}/GetDeliveryCharges?StateID=${stateID}&DistrictID=${districtID}`;
  const res = await getApiWithAuthorization(url);

  return res;
};

export const EstoreInvoice = async (userID, order_id) => {
  const url = `${BaseUrl}/EstoreInvoice?USER_ID=${userID}&OrderID=${order_id}`;
  const res = await getApiWithAuthorization(url);

  return res;
};



// --------------------------------------------------
export const GetProductCategoryLookupList = async () => {
  const url = `${NewUpdatedBaseUrl}/ProductCategory/GetProductCategoryLookupList`;
  // const res = await getApiWithoutAuthorization(url);
  const res = await getApiWithAuthorization(url);

  return res;
};

export const GetProductCatLookupList = async (ProductCatKeyID, TempleKeyID, ApplangID, UserKeyID) => {
  // Always include all parameters, even if empty
  const params = new URLSearchParams({
    ProductCatKeyID: ProductCatKeyID || "",
    TempleKeyID: TempleKeyID || "",
    ApplangID: ApplangID || "",
    UserKeyID: UserKeyID || "",
  });

  const url = `${NewUpdatedBaseUrl}/Product/GetProductCatLookupList?${params.toString()}`;



  const res = await getApiWithAuthorization(url);
  return res;
};


export const ProductDetailsBySlug = async (params) => {
  const url = `${NewUpdatedBaseUrl}/Product/ProductDetailsBySlug`;
  const res = await postApiWithoutAuthorization(url, params);
  return res;
};

export const AddUpdateRemoveCart = async (params) => {
  const url = `${NewUpdatedBaseUrl}/Product/AddUpdateRemoveCart`;
  const res = await postApiWithAuthorization(url, params);
  return res;
};

export const GetProductCartList = async (Type, UserKeyID) => {
  let url = ""
  if (Type === null || Type === undefined || Type === "") {
    url = `${NewUpdatedBaseUrl}/Product/GetProductCartList?Type=&UserKeyID=${UserKeyID}`;
  } else {
    url = `${NewUpdatedBaseUrl}/Product/GetProductCartList?Type=${Type}&UserKeyID=${UserKeyID}`;
  }

  const res = await getApiWithAuthorization(url);
  return res;
};
export const AddUpdateProductBooking = async (params) => {
  const url = `${NewUpdatedBaseUrl}/Product/AddUpdateProductBooking`;
  const res = await postApiWithAuthorization(url, params);
  return res;
};
export const GetProductOrderDetails = async (EstoreBookingKeyID,AppLangID) => {
  const url = `${NewUpdatedBaseUrl}/Product/GetProductOrderDetails?EstoreBookingKeyID=${EstoreBookingKeyID}&AppLangID=${AppLangID}`;
  const res = await getApiWithAuthorization(url);
  return res;
};

export const GetProductBookingList = async (params, UserKeyID) => {
  const url = `${NewUpdatedBaseUrl}/Product/GetProductBookingList?UserKeyID=${UserKeyID}`;
  const res = await postApiWithAuthorization(url, params);
  return res;
};

export const GetPopolarProductList = async (AppLangID, ProductCatKeyID, TempleKeyID) => {
  let url = ""
  if (TempleKeyID === null || TempleKeyID === undefined || TempleKeyID === "") {
    url = `${NewUpdatedBaseUrl}/Product/GetPopolarProductList?AppLangID=${AppLangID}&ProductCatKeyID=${ProductCatKeyID}&TempleKeyID=`;
  } else {
    url = `${NewUpdatedBaseUrl}/Product/GetPopolarProductList?AppLangID=${AppLangID}&ProductCatKeyID=&TempleKeyID=${TempleKeyID}`;
  }


  const res = await getApiWithoutAuthorization(url);
  return res;
};

export const GetProductSubPackageOrderListByUserID = async (params, UserKeyID, AppLangID) => {
  const url = `${NewUpdatedBaseUrl}/Product/GetProductSubPackageOrderListByUserID?UserKeyID=${UserKeyID}&AppLangID=${AppLangID}`;
  const res = await postApiWithAuthorization(url, params);
  return res;
};

export const GetProductSubPackageOrderDetails = async (EstoreBookingKeyID) => {
  const url = `${NewUpdatedBaseUrl}/Product/GetProductSubPackageOrderDetails?EstoreBookingKeyID=${EstoreBookingKeyID}`;
  const res = await getApiWithAuthorization(url);
  return res;
};